import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import SettingCard from './components/SettingCard';
import { Hammer, SlidersHorizontal } from 'lucide-react';

const AccountList = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center mb-4">
          Settings
        </CardTitle>
        <CardDescription>Manage Users, rates and more</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-4">
        <SettingCard
          title="General"
          description="Manage general settings like rate, logo etc."
          icon={<SlidersHorizontal />}
          to="/setting/general"
        />
        <SettingCard
          title="Accounts"
          description="Manage admin users."
          icon={<Hammer />}
          to="/setting/accounts"
        />
      </CardContent>
    </Card>
  );
};

export default AccountList;
